import React from 'react';
import { motion } from 'framer-motion';
export function TTPMMechanismSection() {
  const cards = [{
    num: '01',
    title: '1. Tensión fuera',
    text: 'Primero se reduce la activación física que mantiene al sistema nervioso en alerta. Cuando el cuerpo está tenso, el sonido se siente más grande. Cuando el cuerpo baja la guardia, la percepción puede suavizarse.'
  }, {
    num: '02',
    title: '2. Transferencia de atención',
    text: 'Después, guías tu atención hacia estímulos neutros y seguros. Esto evita que tu mente vuelva una y otra vez al zumbido.'
  }, {
    num: '03',
    title: '3. Patrón de habituación',
    text: 'Finalmente, usas una secuencia repetida que le enseña al cerebro: ‘Esto no necesita mi vigilancia.’ Con práctica, muchas personas sienten que el sonido pierde fuerza emocional. Y cuando pierde carga emocional, dormir se vuelve más posible.'
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-281">
      <div className="max-w-5xl mx-auto" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-283">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-284">
            El Mecanismo TTPM™: Tres pasos para calmar la vigilancia auditiva
            nocturna
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto" data-id="element-285">
            TTPM significa una secuencia simple para bajar la alerta, redirigir
            la atención y facilitar la habituación.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-286">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-[#0B1224] p-8 rounded-xl border border-[#15203B] relative shadow-[0_0_15px_rgba(246,198,91,0.05)] hover:border-[#F6C65B]/30 transition-colors" data-id="element-287">
              <div className="absolute -top-6 left-8 w-12 h-12 bg-[#F6C65B] text-[#070B16] font-bold text-xl rounded-full flex items-center justify-center shadow-lg" data-id="element-288">
                {card.num}
              </div>
              <h3 className="text-xl font-bold text-white mt-4 mb-4" data-id="element-289">
                {card.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-290">{card.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-16 flex justify-center" data-id="element-291">
          <a href="#comprar" className="bg-[#F6C65B] hover:bg-[#FFD680] text-[#070B16] font-bold text-lg px-8 py-4 rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(246,198,91,0.3)] transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto" data-id="element-292">
            Quiero empezar esta noche
          </a>
        </motion.div>
      </div>
    </section>;
}